/*
 * Copyright © 2024 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {Injectable} from '@angular/core';
import type {TranslocoTranspiler, TranspileParams} from '@jsverse/transloco';
import {isObject} from '@jsverse/transloco';
import {MessageFormatTranspiler} from '@jsverse/transloco-messageformat';

/**
 * MessageFormatTranspiler is using the DefaultTranspiler, which replaces all "{{" values in the template string.
 * It is too greedy and breaks messageformat syntax.
 *
 * For instance, the string
 * '{isActive, select, true{Aktuell } other{}}{preposition} {isBeginOfTime, select, true{Eröffnung} other{{date}}}'
 * got replaced to
 * '{isActive, select, true{Aktuell } other{}}{preposition} {isBeginOfTime, select, true{Eröffnung} other01.02.2024}'
 */
@Injectable({providedIn: 'root'})
export class KitAdminTranspiler extends MessageFormatTranspiler implements TranslocoTranspiler {

    public override transpile({value, params, translation, key}: TranspileParams): unknown {
        if (key.endsWith('_MF')) {
            if (!value) {
                return value;
            }

            if (isObject(value) && params) {
                throw new Error(`messageformat customization not implemented for ${key}`);
            } else if (!Array.isArray(value)) {
                // @ts-expect-error we access a private property
                const message = this.messageFormat.compile(value);

                return message(params);
            }

            return value;
        }

        return super.transpile({value, params, translation, key});
    }
}
